import React from "react";
import type { SharedSelectProps } from "./types";
import classNames from "classnames";
import { Label } from "@sprout/typography";

type SelectWrapperProps = Omit<SharedSelectProps, "options" | "placeholder" | "label"> & {
  children: React.ReactNode;
  label?: string;
  selectId: string;
};

export const SelectWrapper = ({
  children,
  disabled,
  error,
  label,
  helperText,
  required,
  selectId,
  ref,
  ...dataProps
}: SelectWrapperProps) => {
  const labelId = `${selectId}-label`;
  const testId = dataProps["data-testid"];

  const containerClassName = classNames({
    select__container: true,
    "select__container--disabled": disabled,
  });

  const labelClassName = classNames({
    select__label: true,
    "select__label--error": !!error,
  });

  return (
    <div className="select" ref={ref}>
      <div className={containerClassName}>
        {label && (
          <Label id={labelId} className={labelClassName} htmlFor={selectId} required={required}>
            {label}
          </Label>
        )}
        {children}
      </div>
      {helperText && (
        <p className="helper-text" aria-live="polite" data-testid={`${testId}-help`}>
          {helperText}
        </p>
      )}
      {error && (
        <p id={`${selectId}-error`} className="helper-text helper-text--error" aria-live="polite">
          {error}
        </p>
      )}
    </div>
  );
};
